import React, { useContext, useEffect, useState } from "react";
import "./MainSidebar.scss";
import { Link, NavLink, useLocation, matchPath } from "react-router-dom";
import db from "../../api/mongodb";
import PicPopup from "../PicPopup";
import homeLogo from "../../images/home-logo.svg";
import projectsLogo from "../../images/projects-logo.svg";
import safeApsLogo from "../../images/safeAps-logo.svg";
import clientsLogo from "../../images/clients-logo.svg";

import Nav from "react-bootstrap/Nav";
import HomeIcon from "../../images/Home.svg";
import ProjectsIcon from "../../images/Projects.svg";
import SafeApsIcon from "../../images/SafeAps.svg";
import ClientsIcon from "../../images/Clients.svg";
import GridViewIcon from "../../images/grid-view.svg";
import ListViewIcon from "../../images/list-view.svg";
import SearchIcon from "../../images/Search.svg";
import SafeLogo from "../../images/SAFE-logo.svg";
import SafeLogo2 from "../../images/SAFE-logo2.svg";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import { UserContext } from "../../api/UserProvider";

const MainSidebar = ({ adminView, activePage }) => {
    const location = useLocation();
    const user = useContext(UserContext)

    return (
        <>
            {/* <div className="nav">
        <div
          className="profile-picture-sidebar"
          onClick={() => {
            setModalOpen(true);
          }}
        >
          <img src={profileImg} />
        </div>
        {modalOpen && <PicPopup setOpenModal={setModalOpen} />}
      </div> */}

            <div className="dashboard-sidebar">
                <header>
                    {/* <a href="#!" className="menu-toggle">
            <i class="fas fa-bars"></i>
            {"|||"}
          </a> */}
                    <NavLink to="/projects/active" className="brand-logo">
                        <img src={SafeLogo2} alt="" />
                    </NavLink>
                </header>
                <nav className="dashboard-sidebar-list">
                    {/* <Link to="#" className="dashboard-sidebar-item">
            <img src={HomeIcon} alt="" style={{ marginRight: 15 }} />
            {"Home"}
          </Link> */}
                    <NavLink
                        to="/projects/active"
                        title="Projects"
                        className={`dashboard-sidebar-item ${location.pathname === "/projects/completed" ? "active" : ""
                            }`}
                    >
                        <img src={ProjectsIcon} alt="Projects" />
                        {"Projects"}
                    </NavLink>
                    {user.role=== "admin" && (
                        <NavLink
                            to="/safeAPs"
                            title="Safe APs"
                            className="dashboard-sidebar-item"
                        >
                            <img src={SafeApsIcon} alt="SAFE-APs" />
                            {"SAFE-APs"}
                        </NavLink>
                    )}
                    <NavLink
                        to="/clients"
                        title="Clients"
                        className="dashboard-sidebar-item"
                    >
                        <img src={ClientsIcon} alt="Clients" />
                        {"Clients"}
                    </NavLink>
                </nav>
            </div>
        </>
    );
};

export default MainSidebar;
